import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import molecules from 'ctsutheme/components/molecules';
import PropTypes from 'prop-types';
import { GetEmptyValue } from 'components';
import _ from 'lodash';
import { TE } from 'appconstants';

const { Divider, Typography } = atoms;
const { List, ListSubHeader } = molecules;

const STARTIntegration = props => {
  const { startInfo } = props;
  const {
    nctnStudyTypeOthers,
    nctnStudyType,
    leadStudyDiseaseCategory
  } = startInfo;

  return (
    <>
      <List
        subheader={(
          <ListSubHeader flex>
          <Typography data-id={`${TE.ID}start${TE.LBL}`} primary header>
              START
            </Typography>
          </ListSubHeader>
)}
      />
      <FormViewContent
        primaryText="NCTN Study Type"
        name="nctnStudyType"
        secondaryText={<GetEmptyValue value={nctnStudyType && _.join(nctnStudyType, ',')} />}
      />
      <Divider />
      <FormViewContent
        primaryText="NCTN Study Type Other"
        name="nctnStudyTypeOthers"
        secondaryText={<GetEmptyValue value={nctnStudyTypeOthers && _.join(nctnStudyTypeOthers, ',')} />}
      />
      <Divider />
      <List />
      <List
        subheader={(
          <ListSubHeader flex >
            <Typography data-id={`${TE.ID}disease_info${TE.LBL}`} primary header style={{ whiteSpace: 'nowrap' }}>
              Disease Information
            </Typography>
          </ListSubHeader>
)}
      />
      <FormViewContent
        primaryText="Lead"
        name="leadDisease"
        secondaryText={(
          <GetEmptyValue
            value={leadStudyDiseaseCategory && leadStudyDiseaseCategory.leadDisease}
          />
)}
      />
      <Divider />
      <FormViewContent
        primaryText="Category"
        name="diseaseCategory"
        secondaryText={(
          <GetEmptyValue
            value={leadStudyDiseaseCategory && leadStudyDiseaseCategory.diseaseCategory}
          />
)}
      />
      <Divider />
      <FormViewContent
        primaryText="Sub-Category"
        name="diseaseSubCategory"
        secondaryText={(
          <GetEmptyValue
            value={leadStudyDiseaseCategory && leadStudyDiseaseCategory.diseaseSubCategory}
          />
)}
      />
      <List />
    </>
  );
};

STARTIntegration.propTypes = {
  startInfo: PropTypes.oneOfType([PropTypes.object])
};

STARTIntegration.defaultProps = {
  startInfo: {}
};

export default STARTIntegration;
